import dayjs from "dayjs";

export const parseStringToDateTimeWithDayjs = (dateString) => {
    if(dateString === null || dateString === undefined) return null;

    return dayjs(dateString).format('DD/MM/YYYY HH:mm')
}

export const parseStringToDateTimeWithDayjsNoTime = (dateString) => {
    return dayjs(dateString).format('YYYY-MM-DD')
}

export const parseStringToDateTimeWithDayjsNoTimeNoYearNoMonthNoDay = (dateString) => {
    return dayjs(dateString).format('HH:mm')
}

